<div class="text-end pt-2 pe-4 patient-footer" style="color: var(--label, #6E7B84); font-size: 13px;">
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16Z" stroke="#6E7B84" stroke-width="1.2"/>
        <line x1="15.1667" y1="8.5" x2="15.1667" y2="16.8333" stroke="#6E7B84" stroke-linecap="round"/>
        <line x1="15.3667" y1="17.2335" x2="19.9" y2="20.6335" stroke="#6E7B84" stroke-linecap="round"/>
    </svg>
    Last login:
    @if (type === 'patient') {
        {{ patient?.user.lastLoginAt == null? '---' : patient?.user.lastLoginAt | timeAgo }}
    }
    @if (type === 'carer') {
        {{ patient?.carer?.user.lastLoginAt == null? '---' : patient?.carer?.user.lastLoginAt | timeAgo }}
    }
    &nbsp;
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M32 20C32 26.6274 26.6274 32 20 32C13.3726 32 8 26.6274 8 20C8 13.3726 13.3726 8 20 8C26.6274 8 32 13.3726 32 20Z" stroke="#6E7B84" stroke-width="1.2"/>
        <line x1="22.9292" y1="12.6565" x2="19.3232" y2="21.0707" stroke="#6E7B84" stroke-linecap="round"/>
        <path d="M19.6 21.1998L14.6667 23.9998" stroke="#6E7B84" stroke-linecap="round"/>
    </svg>
    Last check-in:
    @if (type === 'patient') {
        {{ patient?.user.lastCheckinCompletedAt == null? '---' : patient?.user.lastCheckinCompletedAt | timeAgo }}
    }
    @if (type === 'carer') {
        {{ patient?.carer?.user.lastCheckinCompletedAt == null? '---' : patient?.carer?.user.lastCheckinCompletedAt | timeAgo }}
    }
    <br>

    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M32 20C32 26.6274 26.6274 32 20 32C13.3726 32 8 26.6274 8 20C8 13.3726 13.3726 8 20 8C26.6274 8 32 13.3726 32 20Z" stroke="#6E7B84" stroke-width="1.2"/>
        <line x1="22.9292" y1="12.6565" x2="19.3232" y2="21.0707" stroke="#6E7B84" stroke-linecap="round"/>
        <path d="M19.6 21.1998L14.6667 23.9998" stroke="#6E7B84" stroke-linecap="round"/>
    </svg>
    Last doctor check:
    @if (type === 'patient') {
        {{ patient?.user.lastDoctorCheckAt == null? '---' : patient?.user.lastDoctorCheckAt | timeAgo }}
    }
    @if (type === 'carer') {
        {{ patient?.carer?.user.lastDoctorCheckAt == null? '---' : patient?.carer?.user.lastDoctorCheckAt | timeAgo }}
    }
</div>
